import {
  CreateUtilTierLevelDto,
  DeleteUtilTierLevelDto,
  EditUtilTierLevelDto,
  GetUtilTierLevelDto,
  MessageResponseDto,
  UtilityTierLevelApiFp,
  UtilTierLevelControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTierLevelModel = UtilTierLevelControllerGet200Response;
export type GetTierLevelModel = GetUtilTierLevelDto;
export type MutateResponseTierLevelModel = MessageResponseDto;
export type CreateTierLevelModel = CreateUtilTierLevelDto;
export type UpdateTierLevelModel = EditUtilTierLevelDto;
export type DeleteTierLevelModel = DeleteUtilTierLevelDto;

export const apiTierLevelFp = UtilityTierLevelApiFp(apiConfig);
export const getTierLevelController = apiTierLevelFp.utilTierLevelControllerGet;
export const createTierLevelController = apiTierLevelFp.utilTierLevelControllerCreate;
export const updateTierLevelController = apiTierLevelFp.utilTierLevelControllerEdit;
export const deleteTierLevelController = apiTierLevelFp.utilTierLevelControllerDelete;

export const QueryKeyTierLevel = QueryKey.TierLevel;
